import axios from "axios";
import i18n from "i18next";
import { checkEmpty, getAuthorization, getSetCokieLogin, } from "./util.service";

export const reminderIsCloseStorageKey = "remider-is-close";
export const AuthKeys = {
  token: "token",
  custom_menu: "custom_menu",
  expiresDate: "expiresDate",
  tokenType: "tokenType",
  _key_use: "_key_use",
};
export const APIEndpoint = {
  Login: "auth/login",
  Logout: "auth/logout",
  Me: "auth/me",
  CreateProfile: "auth/me",
  Signup: "auth/signup",
  LoginWithOTP: "auth/verify",
  ChangePasswordVerifyOTP: "auth/change-password-verify",
  CreatePassword: "auth/password",
  ForgotPassword: "auth/forgot-password",
  ChangePassword: "auth/change-password",
  ValidateUser: "/auth/validate-user",
  PasswordPolicy: "auth/password-policy",
  RemoveAccount: "/auth/remove-user"
};

export function saveToken({
  token,
  tokenType,
  expiresDate,
  custom_menu,
  remember,
}: any) {
  if (remember) {
    localStorage.setItem(AuthKeys.token, token);
    localStorage.setItem(AuthKeys.tokenType, tokenType);
    localStorage.setItem(AuthKeys.expiresDate, expiresDate);
  } else {
    sessionStorage.setItem(AuthKeys.token, token);
    sessionStorage.setItem(AuthKeys.tokenType, tokenType);
    sessionStorage.setItem(AuthKeys.expiresDate, expiresDate);
    // sessionStorage.setItem(AuthKeys.custom_menu, custom_menu);
  }
  localStorage.setItem(AuthKeys.token, token);
  localStorage.setItem(AuthKeys.tokenType, tokenType);
  localStorage.setItem(AuthKeys.expiresDate, expiresDate);

  axios
    .get(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.Me, {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    })
    .then((res) => {
      // let prefix = "1234567890";
      // console.log("res : ", res.data);

      let userObj = JSON.stringify(res.data);
      // let prefixEn = btoa(prefix);
      // let userObEn = btoa(userObj);
      var userObEn = btoa(unescape(encodeURIComponent(userObj)))
      let data = userObEn;
      if (remember) {
        localStorage.setItem(AuthKeys._key_use, data);
      } else {
        sessionStorage.setItem(AuthKeys._key_use, data);
      }
      localStorage.setItem(AuthKeys._key_use, data);
      localStorage.setItem("meto", userObj);
      console.log("lang:", res.data.language.toLowerCase());

      if (checkEmpty(localStorage.getItem("lang"))) {
        localStorage.setItem("lang", res.data?.language.toLowerCase());
        i18n.changeLanguage(localStorage.getItem("lang")!, () => {
          console.log(
            `change language to ${localStorage.getItem("lang")!} success`
          );
        });
      }

      localStorage.setItem("chatFontSize", res.data?.fontSize.toLowerCase());
      document.documentElement.setAttribute(
        "chat-size",
        res.data?.fontSize.toLowerCase()
      );
    });
}
export const checkLogin = (history: any) => {
  let token = getToken();
  // console.log("token : ",token);
  if (checkEmpty(token)) {
    return false;
  } else {
    return true;
  }
};
export const checkAuth = () => {
  // let token: any = getToken();
  // console.log("token : ",token);
  // if (checkEmpty(token)) {
  //   return false;
  // } else {
  //   localStorage.setItem(AuthKeys.token, token);
  //   sessionStorage.setItem(AuthKeys.token, token);
  //   return true;
  // }
  // const me = await api.get(UserAPIEndpoint.Me);
  return new Promise((resolve, reject) => {
    axios
      .get(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.Me, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        console.log("checkAuth", res);
        if (res.status != 200) {
          resolve(false);
        } else {
          resolve(true);
        }
      })
      .catch((e) => {
        console.log("checkAuth err=>", e);
        resolve(false);
      });
  });
};

export function getToken() {
  return (
    localStorage.getItem(AuthKeys.token) ||
    sessionStorage.getItem(AuthKeys.token)
  );
}
export function parseUserData(data: any) {
  // let d = data.split(".")[1];
  // console.log(d)
  // console.log(data)
  // d =  atob(d);
  // d = d.substring(10,d.length);
  // d= atob(d);
  // let d = atob(data);
  var d = decodeURIComponent(escape(atob(data)));
  return d;
}
export function getUserData() {
  let data =
    localStorage.getItem(AuthKeys._key_use) ||
    sessionStorage.getItem(AuthKeys._key_use);
  try {
    let userObDeString = parseUserData(data);
    let userData = JSON.parse(userObDeString);
    return userData;
  } catch (e) {
    console.log("e : ", e);
    return null;
  }
}

export function login(username: any, password: any, fcmToken: any) {
  let hash = getSetCokieLogin();
  if (checkEmpty(fcmToken)) {
    // fcmToken = hash;
  }
  return axios.post(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.Login,
    {
      username,
      password,
      fcmToken: fcmToken, //localStorage.getItem("device_token"),
      deviceID: hash,
      deviceToken: fcmToken,
      devicePlatform: "web",
      groupIam2ID: sessionStorage.getItem("window.__RUNTIME_CONFIG__.REACT_APP_GROUP_IAM2_ID"),
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    }
  );
}

export async function logout(username: any, password: any) {
  try {
    let data = await axios.post(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.Logout,
      {
        username,
        password,
      },
      {
        headers: {
          Authorization: `Baraer ${localStorage.getItem(AuthKeys.token) ||
            sessionStorage.getItem(AuthKeys.token)
            }`,
        },
      }
    );
    return data;
  } catch (e) {
    console.error("[LOGOUTERRPR]", e);
  }
}

export async function resetToken(reload: any) {
  try {
    // await logout();
    // await deleteChatDB();
    // await deleteFileDB();
    // await deleteActionCenterDB();
  } catch (e) {
    console.log("[resetToken]", e);
  } finally {
    localStorage.removeItem(AuthKeys.expiresDate);
    localStorage.removeItem(AuthKeys.token);
    localStorage.removeItem(AuthKeys.tokenType);
    localStorage.removeItem("automaticUpdates");
    sessionStorage.removeItem(AuthKeys.expiresDate);
    sessionStorage.removeItem(AuthKeys.custom_menu);
    sessionStorage.removeItem(AuthKeys.token);
    sessionStorage.removeItem(AuthKeys.tokenType);
    sessionStorage.removeItem(reminderIsCloseStorageKey);
    sessionStorage.removeItem("janusServerURL");
    sessionStorage.removeItem("hstart_answer")
    localStorage.removeItem("device_token");

    sessionStorage.removeItem("user-data");
    sessionStorage.removeItem("cz-token");
    sessionStorage.removeItem("organization-id");
    sessionStorage.removeItem("navigation-menu");
    localStorage.removeItem(AuthKeys._key_use);
    sessionStorage.removeItem(AuthKeys._key_use);
    sessionStorage.removeItem("custom_menu")
    sessionStorage.removeItem("task_member")
    sessionStorage.removeItem("task_department")

    if (reload) {
      window.location.reload();
    }
  }
}


export const updateSessionTimeApi = (status: any) => {
  if (!checkEmpty(getToken())) {
    return new Promise((resolve, reject) => {

      axios
        .post(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/auth/update-session-time", {
          status: status
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: getAuthorization(),
          },
        })
        .then((res) => {
          console.log("updateSessionTimeApi", res);
          if (res.status != 200) {
            resolve(false);
          } else {
            resolve(true);
          }
        })
        .catch((e) => {
          console.log("updateSessionTimeApi err=>", e);
          resolve(false);
        });
    });
  }
};
